import React, { useEffect, useState } from 'react';
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    hh: Math.floor(seconds / 3600),
    mm: Math.floor(seconds % 3600 / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="relative z-10 flex flex-col items-center" data-id="element-35" data-mp="3h0z2wwv6xgxl">
      <div className="animate-pulse-alert flex h-16 w-16 items-center justify-center rounded-xl border border-alert/50 bg-white font-display text-3xl font-black tabular-nums text-plum sm:h-20 sm:w-20 sm:text-4xl" style={{
      fontFamily: "Montserrat, sans-serif"
    }} data-id="element-36" data-mp="3h2a913c3z0rv">
        {String(value).padStart(2, '0')}
      </div>
      <span className="mt-2 text-[10px] font-bold uppercase tracking-widest text-plum/50" data-id="element-37" data-mp="10ailbyoqkb57">
        {label}
      </span>
    </div>;
}
type Props = {
  spotsTaken?: number;
};
export function Countdown({
  spotsTaken = 93
}: Props) {
  const {
    hh,
    mm,
    ss
  } = useCountdown(23 * 3600 + 59 * 60 + 26);
  return <section aria-label="Countdown" className="relative w-full overflow-x-hidden bg-transparent" data-id="element-38" data-mp="17qzvq8ue0gtw">
      <div className="mx-auto max-w-3xl px-5 py-8 text-center" style={{
      paddingTop: "9px",
      paddingBottom: "7px"
    }} data-id="element-39" data-mp="12rwpwm6l26kv">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-alert" data-id="element-40" data-mp="f1smofxb48ue">
          🔥 Limited-time offer — ends in:
        </p>

        <div className="relative mt-6 flex items-center justify-center gap-3 sm:gap-5" data-id="element-41" data-mp="a4iy12hqs17m">
          <div className="animate-glow-alert pointer-events-none absolute inset-y-[-25%] left-1/2 w-[min(16rem,80%)] -translate-x-1/2 rounded-full bg-alert/30 blur-2xl" aria-hidden="true" data-id="element-42" data-mp="o41zjcg1seay" />
          <Unit value={hh} label="Hours" data-id="element-43" data-mp="1zh4ddzqriprf" />
          <span className="font-display text-3xl font-black text-plum/25" data-id="element-44" data-mp="1zk8nteutmhqj">:</span>
          <Unit value={mm} label="Min" data-id="element-45" data-mp="1vg0vz8t2glo3" />
          <span className="font-display text-3xl font-black text-plum/25" data-id="element-46" data-mp="s5n1uo52x45b">:</span>
          <Unit value={ss} label="Sec" data-id="element-47" data-mp="s80wwwzregcv" />
        </div>

        <p className="mt-6 text-sm font-semibold text-plum/70" data-id="element-48" data-mp="x3ojr5qrqxf7">
          ⚠️ Then it goes back up to $38 USD. This price will not return.
        </p>

        <div className="mx-auto mt-6 max-w-md" data-id="element-49" data-mp="165freg4vdebp">
          <p className="mb-2 text-left text-xs font-semibold text-plum/60" data-id="element-50" data-mp="1644o0hfc68l4">
            🎟️ Spots at the $19 launch price
          </p>
          <div className="h-3 w-full overflow-hidden rounded-full bg-lilac" data-id="element-51" data-mp="9d2h5tzja5cl">
            <div className="h-full rounded-full bg-alert" style={{
            width: `${spotsTaken}%`
          }} data-id="element-52" data-mp="eerph1vdg4wz" />
          </div>
          <p className="mt-2 text-right text-xs font-bold text-alert" data-id="element-53" data-mp="ie0lkddvwevp">
            Only 12 promo licenses left at this price
          </p>
        </div>
      </div>
    </section>;
}